document
  .querySelectorAll('[data-modal-group="contact-us"]')
  .forEach((modal) => {
    const url = new URL(window.location.href);
    const contactUsModal = modal.querySelector("[data-modal]");
    const contactUsTrigger = modal.querySelector("[data-modal-trigger]");
    const formType = url.searchParams.get("form_type");
    const contactPosted = url.searchParams.get("contact_posted");
    const body = document.body;
    contactUsModal
      .querySelector("[data-modal-close")
      .addEventListener("click", () => {
        contactUsModal.style.display = "none";
        body.style.overflow = "auto";
      });
    contactUsModal.addEventListener("click", (event) => {
      const content = contactUsModal.querySelector(".modal__content");
      if (event.target.contains(content)) {
        contactUsModal.style.display = "none";
        body.style.overflow = "auto";
      }
    });
    contactUsTrigger.addEventListener("click", () => {
      contactUsModal.style.display = "flex";
      body.style.overflow = "auto";
    });
    if (formType === "contact" || contactPosted === "true") {
      contactUsModal.style.display = "flex";
      body.style.overflow = "hidden";
    }
  });

document.querySelectorAll("[data-product-gift-c]").forEach((productDiv) => {
  productDiv.addEventListener("click", async () => {
    const variantId = productDiv.getAttribute("data-product-gift-c");
    const quantity = 1;
    if (variantId) {
      productDiv.style.opacity = "0.5";
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        window.location.href = "/checkout";
      } else {
        alert("Something went wrong.");
      }

      productDiv.style.opacity = "1";
    }
  });
});

document.querySelectorAll("[data-image-form-c]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submitButton = form.querySelector("button[type=submit]");
    const formData = new FormData(form);
    const variantId = formData.get("id");
    const quantity = 1;

    submitButton.disabled = true;
    submitButton.style.opacity = "0.5";

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      window.location.href = "/checkout";
    } else {
      alert("Something went wrong.");
    }

    submitButton.disabled = false;
    submitButton.style.opacity = "1";
  });
});

document
  .querySelectorAll(".site-header__menu-data [data-item]")
  .forEach((el) => {
    const imgUlr = el.getAttribute("data-img");
    const menuPos = parseInt(el.getAttribute("data-menu-position"));
    const showOnMobile = el.getAttribute("data-show-on-mobile") === "true";

    document
      .querySelectorAll("header .page-width .text-center ul.small--hide>li>a")
      .forEach((a, idx) => {
        const marginTop = parseInt(el.getAttribute("data-margin-top"));
        const marginBottom = parseInt(el.getAttribute("data-margin-bottom"));
        const marginLeft = parseInt(el.getAttribute("data-margin-left"));
        const marginRight = parseInt(el.getAttribute("data-margin-right"));
        const imgHeight = parseInt(el.getAttribute("data-img-height")) + "px";
        if (idx === menuPos - 1) {
          a.innerHTML = `<img 
              style="margin-top: ${-marginTop}px; margin-bottom: ${-marginBottom}px; margin-left: ${-marginLeft}px; margin-right: ${-marginRight}px;"
              height="${imgHeight}"
              width="auto" 
              src="${imgUlr}" 
              alt="${a.textContent}"
         >`;
        }
      });

    if (showOnMobile) {
      document
        .querySelectorAll(
          ".mobile-nav > .mobile-nav__item .mobile-nav__link.mobile-nav__link--top-level",
        )
        .forEach((a, idx) => {
          if (idx === menuPos - 1) {
            a.innerHTML = `<img style="margin-top: -10px" height="44px" width="auto" src="${imgUlr}" alt="${a.textContent}">`;
          }
        });
    }
  });
